import { Modal } from 'antd';

export default Modal;



// WEBPACK FOOTER //
// ./src/components/feedback/modal.js